var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fieldset', [_c('legend', {
    class: _vm.libelleStyle + ' truncate mb-2 flex items-center gap-x-1',
    style: _vm.inherits != undefined && _vm.inherits != null && _vm.inherits ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + " "), _vm.required ? _c('span', {
    staticClass: "text-pink-600"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm.libelleIcon ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('clickIcon');
      }
    }
  }, [_c('icon', {
    class: _vm.libelleIconStyle,
    attrs: {
      "name": _vm.libelleIcon
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm.answerArray.length > 1 ? _c('div', {
    staticClass: "p-1 w-full rounded-jauge border justify-start items-start inline-flex"
  }, _vm._l(_vm.answerArray, function (i, index) {
    return _c('AnswerItem', {
      key: i,
      attrs: {
        "is-unevaluated": i === _vm.unevaluatedIndex,
        "reduced": _vm.reduced,
        "answer": i,
        "selected": i === _vm.selected_mut,
        "disabled": _vm.disabled
      },
      on: {
        "select": function ($event) {
          return _vm.select(i, index);
        },
        "unselect": function ($event) {
          return _vm.select(undefined, index);
        }
      }
    });
  }), 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }